import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseLoadingService } from '@fuse/services/loading';

/**
 * The bar reads the service's signals directly instead of copying them into fields from
 * subscriptions. That is what makes it render at all: `app-root` is `OnPush`, and a
 * field written from a subscription marks nothing, so Angular never re-checked this
 * view. A signal read in a template marks its ancestors for traversal itself, which is
 * also why `OnPush` here is now safe rather than merely tidy.
 */
@Component({
  selector: 'fuse-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'fuseLoadingBar',
  imports: [MatProgressBarModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuseLoadingBarComponent {
  private readonly loading = inject(FuseLoadingService);

  readonly autoMode = input(true, { transform: booleanAttribute });

  protected readonly mode = this.loading.mode;
  protected readonly progress = this.loading.progress;
  protected readonly visible = this.loading.visible;

  constructor() {
    effect(() => this.loading.setAutoMode(this.autoMode()));
  }
}
